import styled from 'styled-components';
import { typeStyle, color } from '@m/alchemy-ui/theme';

export const SettingsSubtitle = styled.h2`
  ${typeStyle('bodyL')};
  color: ${color('typeSubHeader', { palette: 'structural' })};
  margin: 0 auto;
  max-width: 600px;
  text-align: center;
`;
